<template>
  <el-dialog
    :title="$t('syncPartnerGoodsPrice.confirmTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div align="center">
      <p>{{$t('syncPartnerGoodsPrice.confirmContent')}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeSyncPartnerGoodsPriceModel">{{$t('syncPartnerGoodsPrice.cancel')}}</el-button>
      <el-button type="primary" @click="syncPartnerGoodsPrice">{{$t('syncPartnerGoodsPrice.confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { syncPartnerGoodsPrice } from '@/api/partner/syncPartnerGoodsPriceApi'

export default {
  name: 'SyncPartnerGoodsPrice',
  data() {
    return {
      dialogVisible: false,
      syncPartnerGoodsPriceInfo: {}
    }
  },
  methods: {
    open(data) {
      this.syncPartnerGoodsPriceInfo = { ...data }
      this.dialogVisible = true
    },
    syncPartnerGoodsPrice() {
      this.syncPartnerGoodsPriceInfo.shopId = getShopId()
      syncPartnerGoodsPrice(this.syncPartnerGoodsPriceInfo)
        .then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('syncPartnerGoodsPrice.syncSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err.message || this.$t('common.requestFailed'))
        })
    },
    closeSyncPartnerGoodsPriceModel() {
      this.dialogVisible = false
    },
    handleClose(done) {
      done()
    }
  }
}
</script>